export const LANDING = "/";
export const SIGN_IN = "/signin";
export const HOME = "/home";
export const TEAM = "/team";
export const ACHIEVEMENTS = "/achievements";
export const LEVELS = "/levels";
export const SPECIALITIES = "/specialities";
export const XP = "/xp";
export const VIEWUSER = "/users/:userId";
